/* AromaCentral — permite arrastrar con el mouse los sliders de Dawn (.slider--desktop),
   ademas de los botones de flecha. El touch ya funciona nativo, no se toca. */
(function () {
  function initDragScroll(slider) {
    if (slider.dataset.acDragInit) return;
    slider.dataset.acDragInit = '1';

    var isDown = false;
    var startX = 0;
    var scrollStart = 0;
    var moved = false;

    slider.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      scrollStart = slider.scrollLeft;
      slider.classList.add('ac-dragging');
    });

    window.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      slider.scrollLeft = scrollStart - dx;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('ac-dragging');
    }

    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    slider.addEventListener(
      'click',
      function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll('.slider--desktop').forEach(initDragScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
